export function initArticleAudio() {
  const listenBlock = document.querySelector(".js-listen-block");

  if (!listenBlock) return;

  const btn = listenBlock.querySelector(".js-listen-btn");

  const openPlayer = () => {
    listenBlock.classList.add("visible");
  };

  btn.addEventListener("click", openPlayer, { once: true });
}
